import React from "react";

const RewardsTooltipIcon = () => {
    return (
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.715 11.75V6.371H8.09V11.75H6.715ZM6.638 3.874H8.156V5.227H6.638V3.874Z" fill="#006AE3" />
            <circle cx="7.5" cy="7.5" r="7.25" stroke="#006AE3" strokeWidth="0.5" />
        </svg>
    );
};

export default RewardsTooltipIcon;